import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { GoPlusCircle } from 'react-icons/go';
import { AiOutlineDelete } from 'react-icons/ai';

// Custom components
import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  appointementGetById,
  patientData,
  patientSearchData,
} from '../../../redux/actions/Files.action';
import {
  addImages,
  deleteImages,
  getImages,
} from '../../../redux/actions/Image.action';
import { IoCloseCircle } from 'react-icons/io5';
import { toast } from 'react-toastify';
import Magnifier from 'react-magnifier';
import screen from '../../../assets/img/screen.png';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { PiWarningCircleBold } from 'react-icons/pi';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const Clinical = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const doctorData = useSelector((state) => state.files);
  const images = useSelector((state) => state.image);
  const patientIds =
    doctorData?.getAppointmentById?.data?.appointmentData?.patientId;

  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    search: '',
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState();
  const [selectedPatientId, setSelectedPatientId] = useState(patientIds);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };
  const [addPhoto, setAddPhoto] = useState(true);
  const addPhotoToggle = () => {
    setAddPhoto(!addPhoto);
  };
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [hideCheckboxVisible, setHideCheckboxVisible] = useState(false);
  const [hideChecked, setHideChecked] = useState(false);
  const [activeImages, setActiveImages] = useState([]);
  const [showHiddenImages, setShowHiddenImages] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedDate1, setSelectedDate1] = useState('');
  const [selectedDate2, setSelectedDate2] = useState('');
  const [currentButton1, setCurrentButton1] = useState(null);
  const [currentButton2, setCurrentButton2] = useState(null);
  const [formDataState, setFormDataState] = useState({
    // dateTime: '',
    // username: '', // Default username value
    hide: '',
    leftSidePhoto: null,
    centerSidePhoto: null,
    rightSidePhoto: null,
    otherPhotos: [],
  });

  const modalToggle = () => {
    setModalOpen(!modalOpen);
  };
  const [deleteModal, setDeleteModal] = useState(false);
  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const [currentImageIndex1, setCurrentImageIndex1] = useState([]);
  const [currentImageIndex2, setCurrentImageIndex2] = useState([]);
  const [imageIndex, setImageIndex] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [mainId, setMainId] = useState();
  const [photoId, setPhotoId] = useState();
  const [checkedImages, setCheckedImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  const handleImageClick = (imageUrl, index) => {
    setCurrentImage(imageUrl);
    setIsOpen(true);
    setCurrentIndex(index);
  };

  const uniqueDates = [
    ...new Set(
      images?.getImages?.data?.data?.map((res) => {
        return new Date(res.createdAt).toLocaleDateString();
      }),
    ),
  ];

  const handleDateChange1 = (date) => {
    // const date = e.target.value;
    setSelectedDate1(date);
    const imageData = images?.getImages?.data?.data || [];
    const formattedDate = date.split('/').reverse().join('-');

    const foundImages = imageData.filter((image) => {
      const imageDate = new Date(image.createdAt).toISOString().split('T')[0];
      return imageDate === formattedDate;
    });

    if (foundImages.length > 0) {
      const allImages = foundImages.map((image) => ({
        left:
          image.leftSidePhoto && (showHiddenImages || !image.leftSidePhoto.hide)
            ? image.leftSidePhoto.url
            : null,
        center:
          image.centerSidePhoto && (showHiddenImages || !image.centerSidePhoto.hide)
            ? image.centerSidePhoto.url
            : null,
        right:
          image.rightSidePhoto && (showHiddenImages || !image.rightSidePhoto.hide)
            ? image.rightSidePhoto.url
            : null,
        others: image.otherPhotos || [],
      }));
      setCurrentImageIndex1(allImages);
    } else {
      setCurrentImageIndex1([]);
    }
  };

  const handleDateChange2 = (date) => {
    // const date = e.target.value;
    setSelectedDate2(date);

    const imageData = images?.getImages?.data?.data || [];

    const formattedDate = date.split('/').reverse().join('-');

    const foundImages = imageData.filter((image) => {
      const imageDate = new Date(image.createdAt).toISOString().split('T')[0];
      return imageDate === formattedDate;
    });

    if (foundImages.length > 0) {
      const allImages = foundImages.map((image) => ({
        left:
          image.leftSidePhoto && (showHiddenImages || !image.leftSidePhoto.hide)
            ? image.leftSidePhoto.url
            : null,
        center:
          image.centerSidePhoto && (showHiddenImages || !image.centerSidePhoto.hide)
            ? image.centerSidePhoto.url
            : null,
        right:
          image.rightSidePhoto && (showHiddenImages || !image.rightSidePhoto.hide)
            ? image.rightSidePhoto.url
            : null,
        others: image.otherPhotos || [],
      }));
      setCurrentImageIndex2(allImages);
    } else {
      setCurrentImageIndex2([]);
    }
  };

  const handleButtonClick1 = (imageUrl) => {
    setCurrentButton1(imageUrl);
  };

  const handleButtonClick2 = (imageUrl) => {
    setCurrentButton2(imageUrl);
  };

  const handlePatientSelect = (patient) => {
    setSelectedPatientId(patient._id);
    setSelectedPatient(patient);
    setDropdownVisible(false);
    navigate(`/master/patientImg/${patient._id}`);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  // Filter image records: keep entries that contain at least one
  // displayable photo (based on `showHiddenImages`) and match the date if set.
  const filteredImages =
    images?.getImages?.data?.data?.filter((res) => {
      // Determine if any photo in this record should be shown
      const hasLeft = res?.leftSidePhoto && (showHiddenImages || !res.leftSidePhoto.hide);
      const hasCenter = res?.centerSidePhoto && (showHiddenImages || !res.centerSidePhoto.hide);
      const hasRight = res?.rightSidePhoto && (showHiddenImages || !res.rightSidePhoto.hide);
      const hasOther =
        res?.otherPhotos && res.otherPhotos.some((p) => showHiddenImages || !p.hide);

      const hasDisplayablePhoto = hasLeft || hasCenter || hasRight || hasOther;

      if (!hasDisplayablePhoto) return false;

      // Date filter logic
      if (!selectedDate) return true;

      return new Date(res.createdAt).toLocaleDateString() === selectedDate;
    }) || [];
  // const filteredImages = images?.getImages?.data?.data?.filter((res) => {
  //   if (!selectedDate) return true;
  //   return new Date(res.createdAt).toLocaleDateString() === selectedDate
  // }) || [];

  console.log('filteredImagesfilteredImages : ', filteredImages);

  useEffect(() => {
    if (patientIds) {
      setSelectedPatientId(patientIds);
    }
  }, [patientIds]);

  useEffect(() => {
    if (images?.getImages?.data?.data) {
      const initialActiveImages = Array(images.getImages.data.data.length).fill(
        'left',
      );
      setActiveImages(initialActiveImages);
    }
  }, [images]);

  const handleImageChange = (index, position) => {
    setActiveImages((prev) => {
      const newActiveImages = [...prev];
      newActiveImages[index] = position;
      return newActiveImages;
    });
  };

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsCheckboxChecked(checked);
  };

  const searchData = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
    };
    setSearchDefault(newSearchParams);
    dispatch(patientSearchData(newSearchQuery));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e, photoKey) => {
    const file = e.target.files[0];
    if (file) {
      setHideCheckboxVisible(true);
    }
    setFormDataState((prevState) => ({
      ...prevState,
      [photoKey]: file,
    }));
  };

  const [checkboxStates, setCheckboxStates] = useState({
    leftSidePhoto: false,
    centerSidePhoto: false,
    rightSidePhoto: false,
  });

  const handleHideCheckboxChange = (position) => {
    setCheckboxStates((prevStates) => ({
      ...prevStates,
      [position]: !prevStates[position],
    }));
    setHideChecked(true);
  };

  const handleMultipleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const updatedOtherPhotos = files.map((file) => ({
      file,
      hide: false,
    }));

    setFormDataState((prevState) => ({
      ...prevState,
      otherPhotos: [...prevState.otherPhotos, ...updatedOtherPhotos],
    }));
  };

  const removeImage = (photoKey) => {
    setFormDataState((prevState) => ({ ...prevState, [photoKey]: null }));
  };

  const removeOtherPhoto = (index) => {
    setFormDataState((prevState) => {
      const updatedOtherPhotos = [...prevState.otherPhotos];
      updatedOtherPhotos.splice(index, 1);
      return { ...prevState, otherPhotos: updatedOtherPhotos };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();

    formData.append('userId', selectedPatientId);

    if (formDataState.leftSidePhoto) {
      formData.append('leftSidePhoto', formDataState.leftSidePhoto);
      formData.append(
        'leftSidePhotoHide',
        checkboxStates.leftSidePhoto ? true : false,
      );
    }

    if (formDataState.centerSidePhoto) {
      formData.append('centerSidePhoto', formDataState.centerSidePhoto);
      formData.append(
        'centerSidePhotoHide',
        checkboxStates.centerSidePhoto ? true : false,
      );
    }

    if (formDataState.rightSidePhoto) {
      formData.append('rightSidePhoto', formDataState.rightSidePhoto);
      formData.append(
        'rightSidePhotoHide',
        checkboxStates.rightSidePhoto ? true : false,
      );
    }

    if (formDataState.otherPhotos.length > 0) {
      formDataState.otherPhotos.forEach((photoObj, index) => {
        formData.append('otherPhotos', photoObj.file);
      });

      const otherPhotosHideArray = formDataState.otherPhotos.map((photoObj) =>
        photoObj.hide ? 'true' : 'false',
      );
      formData.append('otherPhotosHide', JSON.stringify(otherPhotosHideArray));
    }

    dispatch(addImages(formData, selectedPatientId)).then(() => {
      setFormDataState({
        // dateTime: '',
        hide: '',
        leftSidePhoto: null,
        centerSidePhoto: null,
        rightSidePhoto: null,
        otherPhotos: [],
      });
      setIsLoading(false);
      setHideCheckboxVisible(false);
      setHideChecked(false);
    });
  };

  useEffect(() => {
    dispatch(patientData());
    if (id) {
      dispatch(appointementGetById(id));
    }
    if (selectedPatientId) {
      dispatch(getImages(selectedPatientId));
    }
  }, [id, patientIds, selectedPatientId]);

  const handleHideChange = () => {
    setShowHiddenImages((prev) => !prev);
  };

  const viewAllImages = () => {
    setSelectedDate('');
  };

  const toggleHideOtherPhoto = (index) => {
    setFormDataState((prevState) => {
      const updatedOtherPhotos = prevState.otherPhotos.map((photoObj, i) => {
        if (i === index) {
          return { ...photoObj, hide: !photoObj.hide };
        }
        return photoObj;
      });
      return { ...prevState, otherPhotos: updatedOtherPhotos };
    });
  };

  const imageArray = filteredImages.flatMap((res) => {
    let images = [];
    if (res?.leftSidePhoto && (showHiddenImages || !res.leftSidePhoto.hide)) {
      images.push(res.leftSidePhoto.url);
    }
    if (res?.centerSidePhoto && (showHiddenImages || !res.centerSidePhoto.hide)) {
      images.push(res.centerSidePhoto.url);
    }
    if (res?.rightSidePhoto && (showHiddenImages || !res.rightSidePhoto.hide)) {
      images.push(res.rightSidePhoto.url);
    }
    if (res?.otherPhotos) {
      res.otherPhotos.forEach((photo) => {
        if (showHiddenImages || !photo.hide) {
          images.push(photo.url);
        }
      });
    }
    return images;
  });

  const handleDeletePhoto = () => {
    if (photoId) {
      const payload = {
        otherPhotoId: photoId,
      };
      dispatch(deleteImages(mainId, selectedPatientId, payload)).then(() => {
        deleteToggle();
      });
    } else {
      dispatch(deleteImages(mainId, selectedPatientId)).then(() => {
        deleteToggle();
      });
    }
  };

  const handleCheckbox = (image, isChecked) => {
    if (isChecked) {
      if (checkedImages.length < 2) {
        setCheckedImages([...checkedImages, image]);
      } else {
        toast.error('Only two images can be selected for comparison.');
      }
    } else {
      setCheckedImages(checkedImages.filter((img) => img !== image));
    }
  };

  const handleCompare = () => {
    if (checkedImages.length === 2) {
      setSelectedImages(checkedImages);
      setModalOpen(true);
    } else {
      toast.error('Please select exactly two images to compare.');
    }
  };

  return (
    <>
      <div className="mt-[100px]">
        <div className="flex items-center justify-between">
          <div className="flex item-end gap-3 me-3">
            <div className="relative w-[300px]">
              <label className="text-sm">Patient Name</label>
              <div
                onClick={toggleDropdown}
                className="flex gap-2 !text-gray-600 rounded-3 py-2 px-4 border-1 items-center"
              >
                <h6 className="mb-0">
                  {selectedPatient?.firstName ||
                    doctorData?.getAppointmentById?.data?.appointmentData
                      ?.firstName ||
                    'Select Patient'}{' '}
                  {selectedPatient?.lastName ||
                    doctorData?.getAppointmentById?.data?.appointmentData
                      ?.lastName}
                </h6>
                <h6 className="border-l-2 mb-0 px-2 !border-[gray]">
                  {selectedPatient?.phoneNumber ||
                    doctorData?.getAppointmentById?.data?.appointmentData
                      ?.phoneNumber}
                </h6>
              </div>
              {isDropdownVisible && (
                <div className="mt-2 p-2 border rounded bg-white shadow w-full absolute top-full h-[200px] overflow-auto left-0">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={searchData}
                    placeholder="Search patient"
                    className="w-full border p-2 mb-2 rounded outline-none"
                  />

                  {doctorData?.allPatient?.data?.PatientData?.length > 0 ? (
                    doctorData?.allPatient?.data?.PatientData?.map((res) => (
                      <p
                        key={res._id}
                        className="mb-2 cursor-pointer"
                        onClick={() => handlePatientSelect(res)}
                      >
                        {res.firstName} {res.lastName} | ( {res.phoneNumber} )
                      </p>
                    ))
                  ) : (
                    <p>No any Data</p>
                  )}
                </div>
              )}
            </div>
            <div className="self-end">
              <label className="text-sm">Date</label>
              {/* <input
                type="date"
                name="startDate"
                className="w-75 outline-none !border-b pb-2"
                value={selectedDate}
                onChange={handleDateChange}
              /> */}
              <div className="dropdown">
                <button
                  className="dropdown-toggle w-[300px] text-left border px-3 py-[6px] rounded outline-none"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedDate ? selectedDate : 'Select Date'}
                </button>
                <ul className="dropdown-menu w-full">
                  {uniqueDates.map((date, index) => (
                    <li key={index}>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => handleDateChange(date)}
                      >
                        {date}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={handleCompare}
              className="bg-theme-dark text-white px-4 py-2 rounded me-3"
            >
              Compaire
            </button>
            <Link
              to=""
              onClick={addPhotoToggle}
              className="bg-theme-dark text-white px-4 py-2 rounded me-3"
            >
              Add Image
            </Link>
            <Link
              to=""
              onClick={viewAllImages}
              className="bg-theme-dark text-white px-4 py-2 rounded me-3"
            >
              View All Image
            </Link>
          </div>
        </div>
        <div className="mt-4 flex items-center gap-3 mb-4">
          <Form.Check
            type="checkbox"
            label="Hide Photo Display"
            name="photo"
            value="photo"
            id="photo"
            onChange={handleHideChange}
          />
          <Form.Check
            type="checkbox"
            label="Compaire Option For"
            name="photo"
            value="photo"
            id="photo"
            onChange={handleCheckboxChange}
          />
        </div>

        <div className="row">
          <div className="col-8">
            <div className="bg-white border p-4 h-full rounded-lg">
              <div className="row">
                {isCheckboxChecked && (
                  <>
                    {/* First Box */}
                    <div className="col-6">
                      <div className="bg-white border h-full rounded-lg  overflow-hidden">
                        <div className="flex items-center p-2 justify-between border-b">
                          <div className="flex items-center gap-2">
                            <label>Date 1 : </label>
                            {/* <input
                                type="date"
                                value={selectedDate1}
                                onChange={handleDateChange1}
                                className='ms-1 outline-none'
                              /> */}
                            <div className="dropdown">
                              <button
                                className="dropdown-toggle w-[200px] text-left border-b px-2 py-1 outline-none"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                {selectedDate1 ? selectedDate1 : 'Select Date'}
                              </button>
                              <ul className="dropdown-menu w-full">
                                {uniqueDates.map((date, index) => (
                                  <li key={index}>
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={() => handleDateChange1(date)}
                                    >
                                      {date}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="h-[300px]">
                          {/* Display image based on button click */}
                          {currentButton1 && (
                            <Magnifier
                              src={currentButton1}
                              className="w-full !h-[300px] object-cover"
                            />
                          )}
                        </div>
                        <div className="border-t py-2 overflow-hidden col-12">
                          <div className="overflow-auto flex items-center gap-2 relative z-20">
                            {currentImageIndex1?.map((res) => {
                              return (
                                <>
                                  {res.left && (
                                    <img
                                      src={res.left}
                                      alt="Left Image"
                                      className="w-[100px] h-[100px] object-cover"
                                      onClick={() =>
                                        handleButtonClick1(res.left)
                                      }
                                    />
                                  )}
                                  {res.center && (
                                    <img
                                      src={res.center}
                                      alt="Center Image"
                                      className="w-[100px] h-[100px] object-cover"
                                      onClick={() =>
                                        handleButtonClick1(res.center)
                                      }
                                    />
                                  )}
                                  {res.right && (
                                    <img
                                      src={res.right}
                                      alt="Right Image"
                                      className="w-[100px] h-[100px] object-cover"
                                      onClick={() =>
                                        handleButtonClick1(res.right)
                                      }
                                    />
                                  )}
                                  {res.others &&
                                    res.others.length > 0 &&
                                    res.others.map((other, idx) => (
                                      <img
                                        key={idx}
                                        src={other.url}
                                        alt="Other"
                                        className="w-[100px] h-[100px] object-cover"
                                        onClick={() =>
                                          handleButtonClick1(other.url)
                                        }
                                      />
                                    ))}
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Second Box */}
                    <div className="col-6">
                      <div className="bg-white border h-full rounded-lg overflow-hidden">
                        <div className="flex items-center p-2 justify-between border-b">
                          <div className="flex items-center gap-2">
                            <label>Date 2 : </label>
                            {/* <input
                                type="date"
                                value={selectedDate2}
                                onChange={handleDateChange2}
                                className='ms-1 outline-none'
                              /> */}
                            <div className="dropdown">
                              <button
                                className="dropdown-toggle w-[200px] text-left border-b px-2 py-1 outline-none"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                {selectedDate2 ? selectedDate2 : 'Select Date'}
                              </button>
                              <ul className="dropdown-menu w-full">
                                {uniqueDates.map((date, index) => (
                                  <li key={index}>
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={() => handleDateChange2(date)}
                                    >
                                      {date}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="h-[300px]">
                          {/* Display image based on button click */}
                          {currentButton2 && (
                            <Magnifier
                              src={currentButton2}
                              className="w-full !h-[300px] object-cover"
                            />
                          )}
                        </div>
                        <div className="py-2 border-t overflow-hidden">
                          <div className="overflow-auto flex items-center gap-2 relative z-20">
                            {currentImageIndex2?.map((res) => {
                              return (
                                <>
                                  {res.left && (
                                    <img
                                      src={res.left}
                                      alt="Left Image"
                                      className="w-[100px] h-[100px] object-cover"
                                      onClick={() =>
                                        handleButtonClick2(res.left)
                                      }
                                    />
                                  )}
                                  {res.center && (
                                    <img
                                      src={res.center}
                                      alt="Center Image"
                                      className="w-[100px] h-[100px] object-cover"
                                      onClick={() =>
                                        handleButtonClick2(res.center)
                                      }
                                    />
                                  )}
                                  {res.right && (
                                    <img
                                      src={res.right}
                                      alt="Right Image"
                                      className="w-[100px] h-[100px] object-cover"
                                      onClick={() =>
                                        handleButtonClick2(res.right)
                                      }
                                    />
                                  )}
                                  {res.others &&
                                    res.others.length > 0 &&
                                    res.others.map((other, idx) => (
                                      <img
                                        key={idx}
                                        src={other.url}
                                        alt="Other"
                                        className="w-[100px] h-[100px] object-cover"
                                        onClick={() =>
                                          handleButtonClick2(other.url)
                                        }
                                      />
                                    ))}
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {!isCheckboxChecked && (
                <>
                  {!isCheckboxChecked && (
                    <div className="row gy-4">
                      {filteredImages?.length > 0 ? (
                        filteredImages.map((res, index) => {
                          const allPhotosNull =
                            !res.leftSidePhoto &&
                            !res.centerSidePhoto &&
                            !res.rightSidePhoto;

                          if (allPhotosNull) {
                            return null;
                          }

                          const imageUrls =
                            activeImages[index] === 'left'
                              ? res.leftSidePhoto?.url
                              : activeImages[index] === 'center'
                              ? res.centerSidePhoto?.url
                              : activeImages[index] === 'right'
                              ? res.rightSidePhoto?.url
                              : null;

                          return (
                            <div key={index} className="col-4">
                              <div className="bg-white border rounded-lg overflow-hidden mb-4">
                                <span className="flex items-center justify-between p-2 border-b text-xs">
                                  <div>
                                    Date:{' '}
                                    {new Date(res.createdAt).toLocaleDateString(
                                      'en-GB',
                                      {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                      },
                                    )}
                                  </div>
                                  <div>
                                    Time:{' '}
                                    {new Date(res.createdAt).toLocaleTimeString(
                                      'en-GB',
                                      {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                      },
                                    )}
                                  </div>
                                </span>
                                <div className="h-[200px] p-2 relative">
                                  <div className="absolute top-3 right-3 d-flex items-center gap-2">
                                    <div
                                      onClick={() => {
                                        deleteToggle();
                                        setMainId(res._id);
                                        setPhotoId(null);
                                      }}
                                      className="bg-white p-1 rounded cursor-pointer shadow w-[30px] h-[30px] d-flex items-center justify-center"
                                    >
                                      <AiOutlineDelete />
                                    </div>
                                    <div
                                      className="bg-white p-1 rounded cursor-pointer shadow-sm w-[30px] h-[30px]"
                                      onClick={() => {
                                        // Determine which image to open based on the active image
                                        let imageUrl = '';
                                        if (
                                          activeImages[index] === 'left' &&
                                          (res?.leftSidePhoto?.hide
                                            ? showHiddenImages
                                            : !res?.leftSidePhoto?.hide)
                                        ) {
                                          imageUrl = res?.leftSidePhoto?.url;
                                        } else if (
                                          activeImages[index] === 'center' &&
                                          (res?.centerSidePhoto?.hide
                                            ? showHiddenImages
                                            : !res?.centerSidePhoto?.hide)
                                        ) {
                                          imageUrl = res?.centerSidePhoto?.url;
                                        } else if (
                                          activeImages[index] === 'right' &&
                                          (res?.rightSidePhoto?.hide
                                            ? showHiddenImages
                                            : !res?.rightSidePhoto?.hide)
                                        ) {
                                          imageUrl = res?.rightSidePhoto?.url;
                                        }
                                        if (imageUrl) {
                                          const photoIndex =
                                            imageArray.indexOf(imageUrl);
                                          handleImageClick(
                                            imageUrl,
                                            photoIndex,
                                          );
                                        }
                                      }}
                                    >
                                      <img
                                        src={screen}
                                        alt="view full screen"
                                      />
                                    </div>
                                  </div>

                                  <div className="absolute top-3 left-3">
                                    <input
                                      type="checkbox"
                                      onChange={(e) =>
                                        handleCheckbox(
                                          imageUrls,
                                          e.target.checked,
                                        )
                                      }
                                      checked={checkedImages.includes(
                                        imageUrls,
                                      )}
                                      className="w-[16px] h-[16px] accent-theme-dark"
                                    />
                                  </div>

                                  {activeImages[index] === 'left' &&
                                    (res?.leftSidePhoto?.hide
                                      ? showHiddenImages
                                      : !res?.leftSidePhoto?.hide) && (
                                      <img
                                        src={res?.leftSidePhoto?.url}
                                        className="w-full h-full object-cover"
                                        alt="left side patient image"
                                      />
                                    )}
                                  {activeImages[index] === 'center' &&
                                    (res?.centerSidePhoto?.hide
                                      ? showHiddenImages
                                      : !res?.centerSidePhoto?.hide) && (
                                      <img
                                        src={res?.centerSidePhoto?.url}
                                        className="w-full h-full object-cover"
                                        alt="center side patient image"
                                      />
                                    )}
                                  {activeImages[index] === 'right' &&
                                    (res?.rightSidePhoto?.hide
                                      ? showHiddenImages
                                      : !res?.rightSidePhoto?.hide) && (
                                      <img
                                        src={res?.rightSidePhoto?.url}
                                        className="w-full h-full object-cover"
                                        alt="right side patient image"
                                      />
                                    )}
                                </div>
                                <div className="flex items-center justify-between border-t">
                                  <Link
                                    to=""
                                    className={`px-4 col-4 text-sm text-center border-r py-2 ${
                                      activeImages[index] === 'left'
                                        ? 'bg-theme-dark text-white'
                                        : ''
                                    }`}
                                    onClick={() =>
                                      handleImageChange(index, 'left')
                                    }
                                  >
                                    Left
                                  </Link>
                                  <Link
                                    to=""
                                    className={`px-4 col-4 text-sm text-center border-r py-2 ${
                                      activeImages[index] === 'center'
                                        ? 'bg-theme-dark text-white'
                                        : ''
                                    }`}
                                    onClick={() =>
                                      handleImageChange(index, 'center')
                                    }
                                  >
                                    Center
                                  </Link>
                                  <Link
                                    to=""
                                    className={`px-4 col-4 text-sm text-center py-2 ${
                                      activeImages[index] === 'right'
                                        ? 'bg-theme-dark text-white'
                                        : ''
                                    }`}
                                    onClick={() =>
                                      handleImageChange(index, 'right')
                                    }
                                  >
                                    Right
                                  </Link>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p className="text-2xl flex items-center justify-center w-full h-full">
                          No Any Images
                        </p>
                      )}

                      {filteredImages?.length > 0 &&
                        filteredImages?.map((res) => {
                          return (
                            <>
                              {res?.otherPhotos?.length > 0 &&
                                res.otherPhotos?.map(
                                  (photo, i) =>
                                    (!photo.hide || showHiddenImages) && (
                                      <div key={i} className="col-4">
                                        <div className="bg-white border rounded-lg overflow-hidden mb-4">
                                          <span className="flex items-center justify-between p-2 border-b text-xs">
                                            <div>
                                              Date:{' '}
                                              {new Date(
                                                res.createdAt,
                                              ).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                              })}
                                            </div>
                                            <div>
                                              Time:{' '}
                                              {new Date(
                                                res.createdAt,
                                              ).toLocaleTimeString('en-GB', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                              })}
                                            </div>
                                          </span>
                                          <div className="h-[200px] p-2 relative">
                                            <div className="absolute top-3 right-3 d-flex items-center gap-2">
                                              <div
                                                onClick={() => {
                                                  deleteToggle();
                                                  setMainId(res._id);
                                                  setPhotoId(photo._id);
                                                }}
                                                className="bg-white p-1 rounded cursor-pointer shadow w-[30px] h-[30px] d-flex items-center justify-center"
                                              >
                                                <AiOutlineDelete />
                                              </div>
                                              <div
                                                onClick={() => {
                                                  if (photo.url) {
                                                    handleImageClick(
                                                      photo.url,
                                                      imageArray.indexOf(
                                                        photo.url,
                                                      ),
                                                    );
                                                  }
                                                }}
                                                className="bg-white p-1 cursor-pointer rounded shadow-sm w-[30px] h-[30px"
                                              >
                                                <img src={screen} />
                                              </div>
                                            </div>
                                            <div className="absolute top-3 left-3">
                                              <input
                                                type="checkbox"
                                                onChange={(e) =>
                                                  handleCheckbox(
                                                    photo.url,
                                                    e.target.checked,
                                                  )
                                                }
                                                checked={checkedImages.includes(
                                                  photo.url,
                                                )}
                                                className="w-[16px] h-[16px] accent-theme-dark"
                                              />
                                            </div>
                                            <img
                                              src={photo.url}
                                              className="w-full h-full object-cover"
                                              alt={`other patient image ${i}`}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                )}
                            </>
                          );
                        })}

                      {isOpen && (
                        <Lightbox
                          mainSrc={currentImage}
                          nextSrc={
                            imageArray[(currentIndex + 1) % imageArray.length]
                          }
                          prevSrc={
                            imageArray[
                              (currentIndex - 1 + imageArray.length) %
                                imageArray.length
                            ]
                          }
                          onMoveNextRequest={() => {
                            const nextIndex =
                              (currentIndex + 1) % imageArray.length;
                            setCurrentIndex(nextIndex);
                            setCurrentImage(imageArray[nextIndex]);
                          }}
                          onMovePrevRequest={() => {
                            const prevIndex =
                              (currentIndex - 1 + imageArray.length) %
                              imageArray.length;
                            setCurrentIndex(prevIndex);
                            setCurrentImage(imageArray[prevIndex]);
                          }}
                          onCloseRequest={() => setIsOpen(false)}
                        />
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {addPhoto && (
            <div className="col-4">
              <div className="bg-white border rounded-lg">
                <div className="px-4 py-2 border-b text-xl">Add Photo</div>
                <div className="p-4">
                  {/* <div className='mb-3'>
                      <label className='mb-1 block'>Date & Time</label>
                      <input
                        type='datetime-local'
                        name='dateTime'
                        value={formDataState.dateTime}
                        onChange={handleInputChange}
                        className='border rounded-lg px-3 py-2 w-full outline-none'
                      />
                    </div> */}
                  {/* <div className='mb-3'>
                      <label className='mb-1 block'>Username</label>
                      <input
                        type='text'
                        name='username'
                        value={formDataState.username}
                        disabled
                        placeholder='Recep name'
                        className='border rounded-lg px-3 py-2 w-full outline-none'
                      />
                    </div> */}
                  <div className="mb-3">
                    <label className="mb-3 block">Photo Upload</label>
                    <div className="row gy-4">
                      {[
                        'leftSidePhoto',
                        'centerSidePhoto',
                        'rightSidePhoto',
                      ].map((position, idx) => (
                        <div className="col-4" key={position}>
                          <label className="flex items-center justify-between text-sm mb-1">
                            {position.replace(/([A-Z])/g, ' $1')}
                            {hideCheckboxVisible && (
                              <Form.Check
                                type="checkbox"
                                checked={checkboxStates[position]}
                                onChange={() =>
                                  handleHideCheckboxChange(position)
                                }
                              />
                            )}
                          </label>
                          <label className="w-full relative">
                            <input
                              type="file"
                              className="d-none"
                              onChange={(e) => handleFileChange(e, position)}
                            />
                            <div className="border-2 p-3 h-[100px] w-full flex items-center justify-center border-dashed rounded-lg relative">
                              {formDataState[position] ? (
                                <div className="h-full w-full flex items-center justify-center">
                                  <img
                                    src={URL.createObjectURL(
                                      formDataState[position],
                                    )}
                                    alt={position}
                                    className="h-full object-cover"
                                  />
                                  <IoCloseCircle
                                    className="text-2xl text-black absolute top-1 right-1 cursor-pointer"
                                    onClick={() => removeImage(position)}
                                  />
                                </div>
                              ) : (
                                <GoPlusCircle className="text-3xl text-gray-400" />
                              )}
                            </div>
                          </label>
                        </div>
                      ))}
                      <div className="col-12">
                        <label className="block text-sm mb-1">
                          Other Photos
                        </label>
                        <label className="w-full">
                          <input
                            type="file"
                            className="d-none"
                            multiple
                            onChange={handleMultipleFileChange}
                          />
                          <div className="border-2 p-3 h-[100px] w-full flex items-center justify-center border-dashed rounded-lg">
                            {formDataState.otherPhotos.length > 0 ? (
                              <div className="flex flex-wrap gap-2">
                                {formDataState.otherPhotos.map(
                                  (photoObj, index) => (
                                    <div key={index} className="relative">
                                      <img
                                        src={URL.createObjectURL(photoObj.file)}
                                        alt={`other-${index}`}
                                        className="h-20 w-20 object-cover"
                                      />
                                      <IoCloseCircle
                                        className="text-xl text-white absolute top-0 right-0 cursor-pointer"
                                        onClick={() => removeOtherPhoto(index)}
                                      />
                                      <div className="absolute bottom-0 left-0">
                                        <label className="flex items-center space-x-2">
                                          <Form.Check
                                            type="checkbox"
                                            checked={photoObj.hide}
                                            onChange={() =>
                                              toggleHideOtherPhoto(index)
                                            }
                                          />
                                        </label>
                                      </div>
                                    </div>
                                  ),
                                )}
                              </div>
                            ) : (
                              <GoPlusCircle className="text-3xl text-gray-400" />
                            )}
                          </div>
                        </label>
                      </div>
                      <div className="col-12 text-end">
                        <button
                          disabled={isLoading}
                          className="bg-theme-dark text-white px-4 py-2 rounded me-3"
                          onClick={handleSubmit}
                        >
                          {isLoading ? 'Loading...' : 'Add'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* delete modal */}
      <Modal show={deleteModal} onHide={deleteToggle}>
        <Modal.Body className="p-5">
          <div>
            <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Are You Sure ?</h3>
            <p className="text-md">
              Do you really want to delete these records?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handleDeletePhoto}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalOpen}
        onHide={modalToggle}
        centered
        size="xl"
        className="image_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          <div className="flex gap-3">
            <div className="w-1/2">
              <TransformWrapper>
                <TransformComponent>
                  <img
                    src={selectedImages[0]}
                    alt="Selected Image 1"
                    className="w-full h-full object-cover"
                  />
                </TransformComponent>
              </TransformWrapper>
              {/* <Magnifier src={selectedImages[0]} alt="Selected Image 1" className="w-full h-full object-cover" /> */}
            </div>
            <div className="w-1/2">
              <TransformWrapper>
                <TransformComponent>
                  <img
                    src={selectedImages[1]}
                    alt="Selected Image 2"
                    className="w-full h-full object-cover"
                  />
                </TransformComponent>
              </TransformWrapper>
              {/* <Magnifier src={selectedImages[1]} alt="Selected Image 2" className="w-full h-full object-cover" /> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Clinical;
